<template>
  <div class="l-content">
    <div class="row">
      <div class="col-xs-14 col-xs-offset-2 col-sm-10 col-sm-offset-4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Txt'
}
</script>
<style lang="scss" scoped>
  @import '~@/scss/vars';
  h2 {
    margin-bottom: 28px;
    color: $grey;
  }
  h3 {
    color: $h3-grey;
    margin-bottom: 12px;
  }
  p {
    margin-bottom: 18px;
    &.m-b-0 {
      margin-bottom: 0;
    }
  }
  ul, ol {
    margin: 0;
    padding: 4px 0px 15px 15px;
    li {
      color: $darker-grey;
      margin-bottom: 9px;
    }
  }
  img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Txt.vue